export default __webpack_public_path__ + "static/media/si.1ce575de.svg";